define(['angular', '../ilmn-ui-utils/module', '../ilmn-ui-alert-banner/module', 'ng-idle'], function(angular, ilmnUiUtils, ilmnUiAlertBanner) {
    'use strict';

    var MODULE_NAME = 'ilmn-ui-idle';

    return angular
        .module(MODULE_NAME, ['ngIdle', ilmnUiUtils, ilmnUiAlertBanner])
        .config(['IdleProvider', 'KeepaliveProvider', '$httpProvider', '$ilmnUiSessionTrackerProvider', 'ilmnUiCookieUtilProvider', '$ilmnUiIdleServiceProvider', ModuleConfig])
        .run(['$ilmnUiIdleService', '$ilmnUiIdleMonitoringService', '$log', ModuleRun])
        .name;

    function ModuleConfig($idleProvider, $keepaliveProvider, $httpProvider, $ilmnUiSessionTrackerProvider, ilmnUiCookieUtilProvider, $ilmnUiIdleServiceProvider) {
        var psToken = ilmnUiCookieUtilProvider.get('psToken');
        var idleTimeout = parseInt(ilmnUiCookieUtilProvider.get('idleTimeoutInSeconds')) || 0;

        if(!psToken || idleTimeout <= 0) {
            $ilmnUiIdleServiceProvider.disable(true);
            return;
        }

        $idleProvider.idle(idleTimeout);
        $idleProvider.timeout(30);
        $idleProvider.interrupt('keydown mousedown');

        var platformApi = ilmnUiCookieUtilProvider.get('psTokenIssuingAuthorities');
        var pingInterval = ilmnUiCookieUtilProvider.get('idleTimeoutIntervalCheckInSeconds');
        var platformId = (window.platformconfig)? window.platformconfig.clientId: undefined;

        if(pingInterval && platformApi) {
            platformApi = platformApi.replace(/"/g, '');

            $ilmnUiSessionTrackerProvider.setPlatformBaseurl(platformApi);

            var interceptor = ['$rootScope', '$q', function ($rootScope, $q) {
                return {
                    request: function (config) {
                        if ((config.url.indexOf(platformApi) === 0) && (config.headers) && (!config.headers.Authorization)) {
                            config.headers.Authorization = 'Bearer '+ psToken
                        }
                        return config;
                    },
                    response: function (response) {
                        return response;
                    },
                    responseError: function (response) {
                        if(response.status === 401) {
                            $rootScope.$broadcast('$ilmnUiIdle.platformError');
                        }
                        // otherwise, default behaviour
                        return $q.reject(response);
                    }
                }
            }];
            $httpProvider.interceptors.push(interceptor);

            $keepaliveProvider.trackActivity(true);
            $keepaliveProvider.interval(pingInterval);
            $keepaliveProvider.http({
                method: 'PUT',
                url: platformApi + '/SessionTracker/?clientId=' + platformId
            });
        }

    }

    function ModuleRun($ilmnUiIdleService, $ilmnUiIdleMonitoringService, $log) {
        if(!$ilmnUiIdleService.isDisabled()) {
            $ilmnUiIdleMonitoringService.start();
        } else {
            $log.warn('ilmn-ui-idle: Activity monitoring is disabled.')
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-idle/module.js
// module id = 42
// module chunks = 0 1